export default function HeroContact() {
  return (
    <img 
      src="/contact_us_images/contact_us_hero.png" 
      alt="Business Solutions" 
      className="w-full h-[600px] object-cover rounded-md" // Full width, custom height, and cover for aspect ratio
    />
  );
}
